import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '../components/shared';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useTranslation();

  // Eğer kullanıcı giriş yapmışsa dashboard'a yönlendir
  React.useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  const handleJoinClick = () => {
    navigate('/login');
  };

  const handleSignInClick = () => {
    navigate('/login');
  };

  return (
    <div className="min-h-screen relative overflow-hidden bg-black">
      {/* Background Video */}
      <video
        className="absolute inset-0 w-full h-full object-cover opacity-60"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src="/assest/music.mp4" type="video/mp4" />
        {/* Fallback for browsers that don't support video */}
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900 via-blue-900 to-black" />
      </video>
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50" />
      
      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col">
        {/* Header */}
        <header className="flex items-center justify-between p-6 lg:px-12">
          <div className="flex items-center space-x-2">
            <img src="/assest/logo.png" alt="Distnary" className="h-32 w-auto" />
          </div>
          
          <nav className="flex items-center space-x-8 text-white">
            <LanguageSwitcher />
            <button 
              onClick={handleSignInClick}
              className="bg-transparent border border-white px-6 py-2 rounded-full hover:bg-white hover:text-black transition-all duration-300"
            >
              {t('auth.signIn')}
            </button>
          </nav>
        </header>

        {/* Main Content */}
        <main className="flex-1 flex items-center justify-center px-6 lg:px-12">
          <div className="max-w-4xl text-center text-white">
            <h1 className="text-5xl lg:text-7xl font-bold mb-6 leading-tight">
              {t('landingPage.title.part1')}<br />
              <span className="text-orange-400">{t('landingPage.title.part2')}</span>
            </h1>
            
            <p className="text-xl lg:text-2xl mb-4 font-light">
              {t('landingPage.subtitle')}
            </p>
            
            <p 
              className="text-lg lg:text-xl mb-12 max-w-3xl mx-auto leading-relaxed opacity-90"
              dangerouslySetInnerHTML={{ __html: t('landingPage.description') }}
            />
            
            <button 
              onClick={handleJoinClick}
              className="bg-orange-500 hover:bg-orange-600 text-white text-lg font-semibold px-12 py-4 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg"
            >
              {t('landingPage.joinButton')}
            </button>
          </div>
        </main>

        {/* Bottom Section */}
        <div className="p-6 lg:p-12">
          <div className="flex flex-wrap justify-center gap-8 text-white text-sm opacity-75">
            <span>© 2025 Distnary</span>
            <button
              onClick={() => navigate('/policies?policy=privacy_policy')}
              className="hover:text-orange-400 cursor-pointer transition-colors"
            >
              {t('landingPage.footerLinks.privacy')}
            </button>
            <button
              onClick={() => navigate('/policies?policy=terms_of_use')}
              className="hover:text-orange-400 cursor-pointer transition-colors"
            >
              {t('landingPage.footerLinks.terms')}
            </button>
            <button
              onClick={() => navigate('/policies?policy=cookie_policy')}
              className="hover:text-orange-400 cursor-pointer transition-colors"
            >
              {t('landingPage.footerLinks.cookies') || 'Çerezler'}
            </button>
            <button
              onClick={() => navigate('/policies')}
              className="hover:text-orange-400 cursor-pointer transition-colors"
            >
              {t('landingPage.footerLinks.allPolicies') || 'Tüm Politikalar'}
            </button>
            <button className="hover:text-orange-400 cursor-pointer transition-colors">{t('landingPage.footerLinks.contact')}</button>
            <button className="hover:text-orange-400 cursor-pointer transition-colors">{t('landingPage.footerLinks.blog')}</button>
            <button className="hover:text-orange-400 cursor-pointer transition-colors">{t('landingPage.footerLinks.discover')}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage; 